import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  fetchCredits,
  fetchIntegrations,
  getApiKey,
  jobsStats,
  listProjects,
  type Credits,
} from "../api";
import { Icon } from "../components/Icon";

import { useT } from "../i18n";
export function ProfilePage() {
  const tr = useT();
  const nav = useNavigate();
  const name = localStorage.getItem("pf_name") || "Toi";
  const email = localStorage.getItem("pf_email") || "";
  const hasKey = !!getApiKey();

  const [projects, setProjects] = useState<number | null>(null);
  const [files, setFiles] = useState<number | null>(null);
  const [jobs, setJobs] = useState<number | null>(null);
  const [credits, setCredits] = useState<Credits | null>(null);
  const [integrations, setIntegrations] = useState<{ configured: number; total: number } | null>(null);

  useEffect(() => {
    listProjects().then((ps) => { setProjects(ps.length); setFiles(ps.reduce((n, p) => n + (p.file_count ?? 0), 0)); }).catch(() => {});
    jobsStats().then((s) => setJobs(s.total)).catch(() => setJobs(null));
    fetchCredits().then(setCredits).catch(() => setCredits(null));
    fetchIntegrations().then((i) => setIntegrations({ configured: i.summary.configured, total: i.summary.total })).catch(() => setIntegrations(null));
  }, []);

  const initials = name.split(/\s+/).map((w) => w[0]).join("").slice(0, 2).toUpperCase() || "T";
  const v = (x: number | null) => (x === null ? "—" : String(x));

  return (
    <div>
      <div className="page-head">
        <div>
          <div className="eyebrow" style={{ marginBottom: 8 }}>{tr("Compte")}</div>
          <h1>{tr("Profil")}</h1>
          <div className="sub">{tr("Ton compte, ton usage et l'état de tes intégrations.")}</div>
        </div>
      </div>

      {/* Identity */}
      <div className="card" style={{ marginBottom: 20 }}>
        <div className="row between wrap" style={{ gap: 16 }}>
          <div className="row" style={{ gap: 16 }}>
            <div style={{ width: 64, height: 64, borderRadius: 16, display: "grid", placeItems: "center", fontFamily: "var(--font-display)", fontSize: 24, fontWeight: 700, color: "#06231a", background: "var(--grad)", boxShadow: "0 8px 22px var(--accent-glow)" }}>{initials}</div>
            <div>
              <div style={{ fontSize: 20, fontWeight: 600, fontFamily: "var(--font-display)" }}>{name}</div>
              <div className="muted" style={{ fontSize: 13, marginTop: 2 }}>{email || tr("aucun e-mail défini")}</div>
              <span className={`badge ${hasKey ? "ok" : "warn"}`} style={{ marginTop: 8 }}><span className="dot" /> {tr(hasKey ? "Accès API actif" : "Accès en lecture seule")}</span>
            </div>
          </div>
          <button className="btn" onClick={() => nav("/settings")}><Icon name="edit" size={14} /> {tr("Modifier")}</button>
        </div>
      </div>

      {/* Usage stats */}
      <div className="grid stats" style={{ marginBottom: 20 }}>
        {[
          ["projects", "Projets", v(projects)],
          ["box", "Fichiers 3D", v(files)],
          ["route", "Impressions", v(jobs)],
          ["card", "Crédits", credits?.configured ? String(credits.balance ?? "—") : "—"],
        ].map(([ico, label, val]) => (
          <div key={label} className="card stat">
            <div className="row between">
              <span className="eyebrow">{tr(String(label))}</span>
              <span style={{ color: "var(--accent-3)" }}><Icon name={ico} size={15} /></span>
            </div>
            <div className="num" style={{ fontSize: 28, marginTop: 8 }}>{val}</div>
          </div>
        ))}
      </div>

      {/* Integrations + quick links */}
      <div className="grid cards" style={{ gridTemplateColumns: "1fr 1fr" }}>
        <div className="card hover" onClick={() => nav("/integrations")} style={{ cursor: "pointer" }}>
          <div className="row between" style={{ marginBottom: 8 }}>
            <div className="row" style={{ gap: 9 }}><div style={{ width: 30, height: 30, borderRadius: 8, display: "grid", placeItems: "center", color: "var(--accent-3)", background: "var(--accent-soft)", border: "1px solid var(--accent-line)" }}><Icon name="plug" size={15} /></div><div className="card-title">{tr("Intégrations")}</div></div>
            <Icon name="arrowRight" size={15} />
          </div>
          <div className="muted" style={{ fontSize: 13 }}>{integrations ? `${integrations.configured} / ${integrations.total} ${tr("configurées")}` : tr("Clé requise pour voir l'état")}</div>
        </div>
        <div className="card hover" onClick={() => nav("/settings")} style={{ cursor: "pointer" }}>
          <div className="row between" style={{ marginBottom: 8 }}>
            <div className="row" style={{ gap: 9 }}><div style={{ width: 30, height: 30, borderRadius: 8, display: "grid", placeItems: "center", color: "var(--accent-3)", background: "var(--accent-soft)", border: "1px solid var(--accent-line)" }}><Icon name="shield" size={15} /></div><div className="card-title">{tr("Réglages")}</div></div>
            <Icon name="arrowRight" size={15} />
          </div>
          <div className="muted" style={{ fontSize: 13 }}>{tr("Apparence, clé API, langue, compte.")}</div>
        </div>
      </div>
    </div>
  );
}
